<template>
  <page>
    <div>
      <v-flex xs12>
        <form>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex md6 xs6>
                          <v-text-field
                            v-model="filters.arm"
                            :label="labels.arm"
                            :error-messages="errors.collect('arm')"
                            data-vv-name="arm"
                            :data-vv-as="labels.arm"
                          ></v-text-field>
                        </v-flex>
                        <v-flex md6 xs6>
                          <v-text-field
                            v-model="filters.armName"
                            :label="labels.armName"
                            :error-messages="errors.collect('armName')"
                            data-vv-name="armName"
                            :data-vv-as="labels.armName"
                          ></v-text-field>
                        </v-flex>
                        <v-flex md6 xs6>
                          <v-autocomplete
                            :items="sectorList"
                            v-model="filters.sector"
                            :label="labels.nosectorRenewal"
                            item-text="label"
                            item-value="value"
                            data-vv-name="sector"
                            :data-vv-as="labels.nosectorRenewal"
                            :error-messages="errors.collect('sector')"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex md6 xs6>
                          <v-autocomplete
                            :items="divisionList"
                            v-model="filters.division"
                            :label="labels.division"
                            item-text="label"
                            item-value="value"
                            data-vv-name="division"
                            :data-vv-as="labels.division"
                            :error-messages="errors.collect('division')"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex md6 xs6>
                          <v-autocomplete
                            :items="teamList"
                            v-model="filters.team"
                            :label="labels.team"
                            item-text="label"
                            item-value="value"
                            data-vv-name="team"
                            :data-vv-as="labels.team"
                            :error-messages="errors.collect('team')"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="doNew"> New ARM<v-icon right>mdi-plus</v-icon> </v-btn>
        </v-card-title>
        <v-flex>
          <v-card>
            <v-data-table
              :headers="headers"
              :items="items"
              v-bind:options.sync="pagination"
              :server-items-length="totalItems"
              :loading="loading"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              :no-data-text="noDataText"
            >
              <template v-slot:item="row"
                ><tr>
                  <td>{{ row.item.arm }}</td>
                  <td>{{ row.item.armName }}</td>
                  <td>{{ row.item.sector }}</td>
                  <td>{{ row.item.division }}</td>
                  <td>{{ row.item.team }}</td>
                  <td class="table-action-header">
                    <table-action
                      :rowData="row"
                      review
                      @review="doReview(row.item)"
                      remove
                      @remove="doPromptRemove(row.item)"
                      query
                      @query="doQuery(row.item)"
                    ></table-action>
                  </td></tr
              ></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doDelete">
        <p>Are you sure you want to delete the selected ARM? - {{ selectedProp.arm }}</p>
      </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'

export default {
  data() {
    return {
      sideFunction: [
        {
          text: 'Team',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'team' }
        }
      ],
      toggleArray: [false],
      headers: [
        { text: 'ARM', value: 'arm' },
        { text: 'ARM Name', value: 'armName' },
        { text: 'Sector', value: 'sector' },
        { text: 'Division', value: 'division' },
        { text: 'Team', value: 'team' },
        TableConst.tableActionHeader
      ],
      labels: {
        arm: 'ARM',
        armName: 'ARM Name',
        nosectorRenewal: 'Sector',
        division: 'Division',
        team: 'Team'
      },
      filters: {
        arm: undefined,
        armName: undefined,
        sector: undefined,
        division: undefined,
        team: undefined
      },
      totalItems: 0,
      selectedProp: {
        arm: undefined
      },
      deleteProp: undefined,
      loading: false,
      promptRemove: false,
      sectorList: [],
      divisionList: [],
      teamList: [],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  async mounted() {
    await this.$store.dispatch('armInit')
    this.fetchData(true)
    this.doInit()
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    async doInit() {
      this.fetchData(true)
      this.doFetchSector()
      this.doFetchDivision()
      this.doFetchTeam()
    },
    async fetchData(options) {
      this.resetMessages()
      const apiURI = this.menu.getSchemeArmList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  arm: datamap.arm,
                  armName: datamap.armName,
                  sector: datamap.sector,
                  division: datamap.division,
                  team: datamap.team
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    async doFetchSector() {
      const apiURI = this.menu.sectorList
      if (apiURI) {
        this.loading = true
        try {
          const expand = {
            sector: ''
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          this.sectorList = []
          if (data) {
            data.map((datamap) => {
              const convertList = {
                value: datamap.value,
                label: datamap.label
              }
              this.sectorList.push(convertList)
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doFetchDivision() {
      const apiURI = this.menu.divisionList
      if (apiURI) {
        this.loading = true
        try {
          const expand = {
            sector: ''
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          this.divisionList = []
          if (data) {
            data.map((datamap) => {
              const convertList = {
                value: datamap.value,
                label: datamap.label
              }
              this.divisionList.push(convertList)
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doFetchTeam() {
      const apiURI = this.menu.teamList
      if (apiURI) {
        this.loading = true
        try {
          const expand = {
            division: '',
            sector: ''
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          this.teamList = []
          if (data) {
            data.map((datamap) => {
              const convertList = {
                value: datamap.value,
                label: datamap.label
              }
              this.teamList.push(convertList)
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.arm = undefined
      this.filters.armName = undefined
      this.filters.sector = undefined
      this.filters.division = undefined
      this.filters.team = undefined
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    doReview(obj) {
      this.$router.push({ name: 'armReview', params: { paramMode: 'review', paramObjRes: obj } })
    },
    doNew() {
      this.$router.push({ name: 'armReview', params: { paramMode: 'create' } })
    },
    doQuery(obj) {
      this.$router.push({ name: 'armReview', params: { paramMode: 'query', paramObjRes: obj } })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedProp.arm = data.arm
      }
    },
    async doDelete() {
      const apiURI = this.menu.deleteSchemeArm
      if (apiURI) {
        const expand = this.selectedProp
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(true)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.boIncenSchParam.arm.menu
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
